// Calendar-gated seasonal content. Keys are seasonal ids (used as theme and variant names),
// values are 0-indexed months. Ids not listed here are always active.
export const SEASONAL_MONTHS = {
  halloween: 9, // October
};

export const isSeasonActive = (id, now = new Date()) => {
  const month = SEASONAL_MONTHS[id];
  return month === undefined || now.getMonth() === month;
};

// CSS class for the active seasonal theme, or an empty string when none applies.
export const getSeasonalThemeClass = (now = new Date()) => {
  const id = Object.keys(SEASONAL_MONTHS).find((key) => isSeasonActive(key, now));
  return id ? `theme-${id}` : '';
};
